<template>
  <div id="message_reply">
    <!-- 住戶反映 區塊 -->
    <div class="main">
      <div class="title_bar bg_blue">
        <div class="title">
          住戶意見回饋
        </div>
      </div>
      <div class="blockWrap">
        <i
          class="icon-feedback icon"
          aria-hidden="true"
        />
        <div class="blockWrap-title">
          <span>{{ replyData.TabletNote }}</span>
          <span v-if="replyData.UserName || replyData.UserName === ''">- {{ replyData.UserName || $t('Message.NoRegisteredName') }}</span>
          <span v-if="replyData.UserTabletState !== 1" class="font-red">{{ userTabletStateMap[replyData.UserTabletState] }}</span>
          <p>{{ replyData.CreateAt }}</p>
        </div>
        <el-form
          status-icon
          label-position="top"
        >
          <el-form-item label="類別">
            <el-tag type="type">
              {{ replyData.Type }}
            </el-tag>
          </el-form-item>
          <el-form-item label="住戶回饋">
            <template>
              <div class="reply-content">
                <p>{{ replyData.Content }}</p>
              </div>
            </template>
          </el-form-item>
          <el-form-item label="附加圖片">
            <template>
              <p
                v-if="images.length === 0"
                class="imgTip"
              >
                無
              </p>
              <div
                v-else
                class="file-wrap"
              >
                <div class="images-wrapper">
                  <div
                    v-for="(image, imageIndex) in images"
                    :key="imageIndex"
                    class="file-img"
                    :style="{ backgroundImage: 'url(' + image + ')' }"
                    @click="index = imageIndex"
                  />
                </div>
              </div>
            </template>
          </el-form-item>
        </el-form>
        <div v-if="isView && !replyData.ReplyAt" class="bottomControl">
          <el-button
            round
            @click="$router.push({name:'message'})"
          >
            返回意見反映列表
          </el-button>
        </div>
      </div>
    </div>
    <!-- 回覆區 -->
    <div v-if="!isView || replyData.ReplyAt" class="main">
      <div class="title_bar bg_green">
        <div class="title">
          社區意見回饋
        </div>
      </div>
      <div class="blockWrap">
        <i
          class="el-icon-user icon"
          aria-hidden="true"
        />
        <span class="userName">{{ loginUserName }}</span>
        <el-form
          ref="replyData"
          class="list"
          status-icon
          :model="replyData"
          label-position="top"
        >
          <el-form-item v-if="!isView">
            <el-input
              v-model="replyData.ReplyContent"
              type="textarea"
              placeholder="請輸入意見回饋"
              maxlength="255"
              show-word-limit
              :autosize="{ minRows: 4}"
              class="textarea"
            />
          </el-form-item>
          <div v-else style="margin-bottom: 22px">
            {{ replyData.ReplyContent }}
          </div>
          <el-form-item label="附加檔案">
            <template v-if="FileMaxNumber != null">
              <MultipleFile
                v-model="replyFile"
                type="file"
                name="file"
                :filearray="replyFile"
                :quantity="FileMaxNumber"
                :disabled="isView"
                @on-fileArray-change="FilesChange"
              />
            </template>
          </el-form-item>
          <el-form-item label="附加圖片">
            <template v-if="ImageMaxNumber != null">
              <MultipleFile
                v-model="replyImages"
                type="img"
                name="img"
                :filearray="replyImages"
                :quantity="ImageMaxNumber"
                :disabled="isView"
                @on-fileArray-change="ImageFilesChange"
              />
            </template>
          </el-form-item>
        </el-form>
      </div>
      <div class="bottomControl">
        <el-button
          round
          @click="$router.push({name:'message'})"
        >
          返回意見反映列表
        </el-button>
        <el-button
          v-if="!isView"
          type="primary"
          :disabled="isDisable"
          round
          @click="submit"
        >
          確定送出
        </el-button>
      </div>
    </div>
    <CoolLightBox
      :items="images"
      :index="index"
      :slideshow="false"
      @close="index = null"
      @on-open="lightBoxOpen"
    />
  </div>
</template>
<script>
import MultipleFile from '@/components/MultipleFile'

export default {
  components: {
    MultipleFile
  },
  data () {
    return {
      replyData: {},
      images: [],
      replyFile: [],
      replyImages: [],
      FileMaxNumber: null,
      ImageMaxNumber: null,
      isDisable: false,
      loginUserName: '',
      replyFileArray: [],
      canClickSubmit: true,
      index: null,
      isView: false,
      userTabletStateMap: {
        2: this.$t('Message.LeavedUser'),
        3: this.$t('Message.DeletedUser')
      }
    }
  },
  mounted () {
    this.getData()
    this.getFileLimited()
    this.loginUserName = JSON.parse(localStorage.getItem('loginUserInfo')).AdminName
    this.isView = this.$route.name === 'messageView'
  },
  methods: {
    // 取得回覆頁詳細資料
    getData () {
      const requestData = {
        Id: this.$route.params.id
      }
      apiMessage.Reply.GetMessageDetail(
        requestData
      ).then(res => {
        this.replyData = _cloneDeep(res.data.Data)
        this.replyData.FileInfo.forEach(item => {
          if (item.FileType === 2) { this.file.push({ Url: item.ExpiringUrl || item.Url }) } else if (item.FileType === 1) { this.images.push(item.ExpiringUrl || item.Url) }
        })
        // 管理員圖片、檔案
        this.replyData.ReplyFileInfo.forEach(item => {
          if (item.FileType === 2) {
            this.replyFile.push({
              uploadUrl: item.Url,
              expiringUrl: item.ExpiringUrl,
              type: 'file',
              file: ''
            })
          } else if (item.FileType === 1) {
            this.replyImages.push({
              uploadUrl: item.Url,
              expiringUrl: item.ExpiringUrl,
              type: 'img',
              file: '',
              BS64: ''
            })
          }
        })
      }).catch(err => {
        console.log('錯誤訊息', err.response)
      })
    },
    // 取得回覆檔案數量限制
    getFileLimited () {
      apiMessage.Reply.GetMessageFileLimited(
      ).then(res => {
        res.data.Data.forEach(item => {
          if (item.FileType === 2) { this.FileMaxNumber = item.Limited } else if (item.FileType === 1) { this.ImageMaxNumber = item.Limited }
        })
      }).catch(err => {
        console.log('錯誤訊息', err.response)
      })
    },
    // 送出回覆按鈕
    async submit () {
      if (this.canClickSubmit) {
        if (this.replyData.ReplyContent === '') {
          this.$alert('您未輸入回覆內容，請輸入後再送出回覆。', '錯誤', {
            confirmButtonText: '確定',
            type: 'error',
            callback: action => {}
          })
        } else if (this.replyFile.length + this.replyImages.length > 0) {
          this.canClickSubmit = false
          this.$loading({
            lock: true,
            text: '資料處理中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          await this.uploadReplyFile()
          await this.postReplyData()
        } else {
          this.canClickSubmit = false
          this.$loading({
            lock: true,
            text: '資料處理中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          document.querySelector('.el-loading-text').innerHTML = '正在寫入資料中請稍後'
          await this.postReplyData()
        }
      }
    },
    // 處理上傳檔案
    async uploadReplyFile () {
      const totalFile = this.replyFile.concat(this.replyImages)
      for (let n = 0; n < totalFile.length; n++) {
        if (totalFile[n].uploadUrl === '') {
          const uploadFormData = new FormData()
          uploadFormData.append('file', totalFile[n].file)
          const fileUrl = await this.fileToUrl(uploadFormData)
          this.replyFileArray.push(
            {
              Url: fileUrl,
              FileType: totalFile[n].type === 'file' ? 2 : 1 // 檔案2  圖片1
            }
          )
        } else {
          this.replyFileArray.push(
            {
              Url: totalFile[n].uploadUrl,
              FileType: totalFile[n].type === 'file' ? 2 : 1
            }
          )
        }
        document.querySelector('.el-loading-text').innerHTML = `檔案已上傳 ${this.replyFileArray.length} 筆，共 ${this.replyFile.length + this.replyImages.length} 筆`
      }
    },
    // 檔案換url
    async fileToUrl (requestData) {
      try {
        const res = await apiMessage.Reply.PostMessageUploadReplyFile(requestData)
        return res.data.Data
      } catch (err) {
        this.$message({
          message: '上傳過程發生異常，請重新再[送出]一次',
          type: 'warning'
        })
        console.log('錯誤訊息：', err.response)
      }
    },
    // post 回覆資料
    async postReplyData () {
      const loadingWrap = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        const requestData = {
          Id: this.$route.params.id,
          Files: this.replyFileArray,
          Content: this.replyData.ReplyContent
        }
        const res = await apiMessage.Reply.PostMessageReply(requestData)
        if (res.data.Status === 1) {
          this.$store.commit('ifMessageReplyEdit', true)
          loadingWrap.close()
          this.$alert('回覆更新完成。', '', {
            confirmButtonText: '確定',
            type: 'success',
            callback: action => {
              if (action === 'confirm') { this.$router.push({ name: 'message' }) }
            }
          })
        } else {
          loadingWrap.close()
          this.$alert('回覆更新失敗。', '', {
            confirmButtonText: '確定',
            type: 'error',
            callback: action => {
              if (action === 'confirm') { this.$router.push({ name: 'message' }) }
            }
          })
        }
        setTimeout(() => {
          this.canClickSubmit = true
        }, 1000)
      } catch (err) {
        loadingWrap.close()
      }
    },
    // 檔案的components回釣函式
    FilesChange (val) {
      this.replyData.Files = val
    },
    // 檔案的components回釣函式
    ImageFilesChange (val) {
      this.replyData.ImageFiles = val
    },
    lightBoxOpen () {
      if (document.querySelector('.cool-lightbox-toolbar__btn[title="Show thumbnails"]')) { document.querySelector('.cool-lightbox-toolbar__btn[title="Show thumbnails"]').style.display = 'none' }
    }
  }
}
</script>
<style lang="sass" scoped>
#message_reply
  padding: 0px
  .main
    min-width: 1140px
    max-width: 1140px
    margin: 0 auto
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    padding: 0px
    margin-top: 50px
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      border-radius: 8px 8px 0px 0px
      padding-left: 30px
      height: 66px
      &.bg_blue
        background-color: $blueColor
      &.bg_green
        background-color: $mainColor
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        text-align: left
        color: $white
    .blockWrap
      text-align: left
      width: 100%
      padding: 20px
      box-sizing: border-box
      color: $mainFontColor
      position: relative
      .icon
        font-size: 35px
        margin: 0px 20px 20px 15px
        display: inline-block
      .blockWrap-title
        display: inline-block
        margin-bottom: 40px
        span
          display: inline-block
          line-height: 150%
          font-size: 18px
          font-weight: bold
          &:nth-child(2)
            margin-left: 5px
        p
          color: $mainFontColor
          margin-top: 2px
      .userName
        display: inline-block
        line-height: 35px
        position: absolute
        top: 20px
        font-weight: bold
        font-size: 18px
      .el-form
        padding-left: 70px
        ::v-deep .el-form-item__label
          color: $mainFontColor
          font-size: 16px
          line-height: 25px
          padding-bottom: 0px
          font-weight: bold
        .reply-content
          padding-top: 8px
          word-break: break-word
          font-size: 16px
          width: 90%
          line-height: 150%
          p
            line-height: 200%
        .imgTip
          font-size: 16px
          padding-top: 8px
          line-height: 150%
        .type
          color: $mainColor
          background: $bgDark3
          font-weight: bold
        .textarea
          width: 90%
          border-radius: 8px
          ::v-deep .el-textarea__inner
            padding-right: 70px
            border: 1px solid $borderDark1
        ::v-deep .el-form-item__content
          .file-wrap
            display: flex
            flex-wrap: wrap
            .file-img
              display: inline-block
              width: 150px
              height: 150px
              cursor: pointer
              margin: 10px
              border: 1px solid $lightFontColor
              position: relative
              overflow: hidden
              border-radius: 8px
              background-position: center
              background-size: cover
              &:hover
                color: $mainFontColor
                border: 1px solid #aaa
                box-shadow: inset 0 1px 2px -1px rgba(0,0,0,.075), 0 0 8px rgba(120,120,120,.5)
                transition: .4s
    .bottomControl
      width: 85%
      margin: 0px auto
      text-align: center
      padding: 30px
      border-top: solid 1px $borderDark1
    .file-tip
      margin-left: 80px

.font-red
  color: $dangerColorHover
</style>
